"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../utils");
var _types = require("./types");
function updateMeetingStatus(status) {
  return (0, _utils.actionCreator)(_types.UPDATE_MEETING_STATUS, status);
}
var _default = exports["default"] = updateMeetingStatus;